import type { ReactNode } from 'react';

import styles from './StatePanel.module.css';

interface StatePanelProps {
  /** Single glyph shown in the gold disc. Decorative. */
  icon: string;
  title: string;
  children: ReactNode;
  /** Optional smaller line below the body copy. */
  hint?: string;
  /** Announce to screen readers when this replaces the form mid-session. */
  live?: boolean;
  /** Rendered below the hint - notices, actions. */
  extra?: ReactNode;
}

/**
 * Terminal state of the waitlist card - shown after submitting, and again after
 * the visitor clicks the opt-in link. One component for both so the two states
 * cannot drift apart visually.
 */
export function StatePanel({ icon, title, children, hint, live = false, extra }: StatePanelProps) {
  return (
    <div className={styles.panel} {...(live ? { role: 'status', 'aria-live': 'polite' as const } : {})}>
      <div className={styles.icon} aria-hidden="true">
        {icon}
      </div>
      <p className={styles.title}>{title}</p>
      <p className={styles.subtitle}>{children}</p>
      {hint !== undefined && <p className={styles.hint}>{hint}</p>}
      {extra}
    </div>
  );
}
